/*
 * File: /src/router/routes/reports.js
 * Created Date: Sunday May 15th 2022
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Sunday, 15th May 2022 8:41:36 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2022 AdBase, Inc.
 */
const ReportsOverview = () =>
  import(
    /* webpackChunkName: "Reports" */ 'src/components/Dashboard/Views/Reports/ReportsOverview.vue'
  );

const ReportList = () =>
  import(
    /* webpackChunkName: "Reports" */ 'src/components/Dashboard/Views/Reports/ReportListing.vue'
  );

const AutomationJourneyViewer = () =>
  import(
    /* webpackChunkName: "Reports" */ 'src/components/Dashboard/Views/Reports/AutomationJourneyViewer.vue'
  );

const KpiReportViewer = () =>
  import(
    /* webpackChunkName: "Reports" */ 'src/components/Dashboard/Views/Reports/KpiReportViewer.vue'
  );

export const reportRoutes = [
  {
    path: 'reports/',
    name: 'Reports',
    component: ReportsOverview,
    meta: { requiresAcl: 'view_reports' },
  },
  {
    path: 'reports/view',
    name: 'ReportView',
    component: ReportList,
    meta: { requiresAcl: 'view_reports' },
    props: (route) => ({
      reportType: route.query.type,
      filterDate: route.query.filterDate,
    }),
  },
  {
    path: 'reports/journey',
    name: 'ContactJourney',
    component: AutomationJourneyViewer,
    meta: { requiresAcl: 'view_reports' },
    props: (route) => {
      let filterDates = null;
      if (route.query.filterDates) {
        const decoded = decodeURIComponent(route.query.filterDates);
        filterDates = JSON.parse(decoded);
      }
      return {
        workflowId: parseInt(route.query.workflowId) || 0,
        contactId: parseInt(route.query.contactId) || 0,
        triggerTaskId: parseInt(route.query.triggerTaskId) || 0,
        actionId: parseInt(route.query.actionId) || 0,
        filterDates,
      };
    },
  },
  {
    path: 'reports/kpi',
    name: 'KPI Report',
    component: KpiReportViewer,
    meta: { requiresAcl: 'view_reports' },
  },
];
